import { useState } from 'react';

import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Stack, styled, Tab, Typography } from '@mui/material';

import BackIconButton from '../../../components/buttons/BackIconButton';

import FeaturedBannerAdvertisementList from './FeaturedBannerAdvertisementList';
import FeaturedBannerAnnouncementList from './FeaturedBannerAnnouncementList';
import FeaturedBannerCategoryList from './FeaturedBannerCategoryList';
import FeaturedBannerPostList from './FeaturedBannerPostList';
import FeaturedBannerSubCategoryList from './FeaturedBannerSubCategoryList';

function AddNewFeaturedBanner() {
  const [value, setValue] = useState('category');

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  return (
    <Container>
      <FullWidthBar>
        <Stack flexDirection="row" alignItems="center" gap={1}>
          <BackIconButton />
          <Typography variant="h5">Add new Featured Banner</Typography>
        </Stack>
      </FullWidthBar>

      <Box sx={{ width: '100%', typography: 'body1' }}>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList onChange={handleChange} aria-label="tabs">
              <Tab label="Category" value="category" />
              <Tab label="Sub-Category" value="sub-category" />
              <Tab label="Article" value="post" />
              {/* <Tab label="Topic" value="topic" /> */}
              <Tab label="Advertisement" value="advertisement" />
              <Tab label="Announcement" value="announcement" />
            </TabList>
          </Box>
          <TabPanel value="category" sx={{ padding: 0 }}>
            <FeaturedBannerCategoryList />
          </TabPanel>
          <TabPanel value="sub-category" sx={{ padding: 0 }}>
            <FeaturedBannerSubCategoryList />
          </TabPanel>
          <TabPanel value="post" sx={{ padding: 0 }}>
            <FeaturedBannerPostList />
          </TabPanel>
          {/* <TabPanel value="topic" sx={{ padding: 0 }}>
            <FeaturedBannerTopicList />
          </TabPanel> */}
          <TabPanel value="advertisement" sx={{ padding: 0 }}>
            <FeaturedBannerAdvertisementList />
          </TabPanel>
          <TabPanel value="announcement" sx={{ padding: 0 }}>
            <FeaturedBannerAnnouncementList />
          </TabPanel>
        </TabContext>
      </Box>
    </Container>
  );
}

export default AddNewFeaturedBanner;

const Container = styled('div')({
  padding: '20px',
  backgroundColor: '#eee',
  flex: 1,
  display: 'flex',
  alignItems: 'stretch',
  flexDirection: 'column',
});

const FullWidthBar = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  margin: '8px 0',
  justifyContent: 'space-between',
  alignItems: 'center',
});
